import React, { useEffect } from "react";
import style from "./index.module.scss";
import { Button, message, Modal, Tooltip } from "antd";
import { BiPaperPlane, BiUndo } from "react-icons/bi";
import { FiClock } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import Countdown from "react-countdown";
import moment from "moment";
import { useInterval } from "react-use";
import useHeaderData from "../../../../Utils/useHeaderData";
import { errorMessage } from "../../../../../../../Utils/useRequest";

interface HeaderProps {
    onSubmit: (
        showConfirm?: boolean
    ) => Promise<{ number: number } | undefined>;
    exerciseId: string;
}

export default function ExerciseTopicsHeader({
    onSubmit,
    exerciseId
}: HeaderProps) {
    const history = useHistory();
    const [headerData, stopStatus, reloadHeadData] = useHeaderData(exerciseId);

    useEffect(() => {
        reloadHeadData();
    }, [exerciseId]);

    useInterval(reloadHeadData, stopStatus);

    function handleSubmit() {
        onSubmit();
    }

    //前端倒计时时间到了处理（后续可能加需求）
    async function timeOutSubmit() {
        try {
            const res = await onSubmit(false); // 如果由后台来收卷, 这一句可以去掉
            const { number } = res || {};
            const message = number ? `还有${number}道题尚未作答.` : "";
            Modal.warn({ content: `截止时间到了, 系统自动收卷. ${message}` });
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <>
            {headerData && (
                <div className={style.root}>
                    <div className={style.wrapper}>
                        <div className={style.left}>
                            <h1 className={style.title}>
                                <Tooltip
                                    title={headerData.description}
                                    placement="bottomLeft">
                                    <span>{headerData.description}</span>
                                </Tooltip>

                                <Button
                                    className={style.back}
                                    onClick={() => history.goBack()}>
                                    <BiUndo size={16} /> 返回
                                </Button>
                            </h1>

                            <div className={style.info}>
                                {headerData.validityTime && (
                                    <span>
                                        {" "}
                                        活动时长&nbsp;&nbsp;
                                        {headerData.validityTime}
                                        &nbsp;&nbsp;分钟&nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                    </span>
                                )}
                                {!headerData.validityTime && (
                                    <span>
                                        活动时长&nbsp;&nbsp;不限
                                        &nbsp;&nbsp;|&nbsp;&nbsp;{" "}
                                    </span>
                                )}
                                开始时间{" "}
                                {moment(headerData.startTime).format(
                                    "MM-DD HH:mm"
                                )}
                            </div>
                        </div>

                        <div className={style.right}>
                            {headerData.validityTime && (
                                <div className={style.time}>
                                    <FiClock size={26} />
                                    倒计时{" "}
                                    <Countdown
                                        onComplete={() => timeOutSubmit()}
                                        daysInHours
                                        date={
                                            moment(
                                                headerData.startTime
                                            ).valueOf() +
                                            headerData.validityTime * 60000
                                        }
                                    />
                                </div>
                            )}
                            <Button
                                type="primary"
                                className={style.button}
                                onClick={() => handleSubmit()}>
                                <BiPaperPlane size={16} /> 提交练习
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
